import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';

import { INQUIRY_TEMPLATE_EDITOR_FORM_NAME } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import useAllThemeFontOptions from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/hooks/useAllThemeFontOptions';
import { SelectStyleInput } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs';
import { ThemeAttributes } from 'dashboard/models/theme';
import { RootState } from 'dashboard/redux/store';

type FontWeightSelectProps = {
  editable: boolean;
  path: string;
  defaultValue?: string;
};

const FONT_FAMILY_FIELD = 'font-family';

const FontFamilySelect = ({ editable, path, defaultValue }: FontWeightSelectProps) => {
  const dispatch = useDispatch();

  const selectedTemplateThemeAttrs = useSelector<RootState, ThemeAttributes>((state) => {
    return state?.inquiryTemplate?.inquiryTemplateTreeData?.inquiryTemplateVersion?.attributes
      ?.theme;
  });

  const fontOptions = useAllThemeFontOptions(selectedTemplateThemeAttrs);

  const handleChange = useCallback(
    (value: string) => {
      dispatch(change(INQUIRY_TEMPLATE_EDITOR_FORM_NAME, `${path}.${FONT_FAMILY_FIELD}`, value));
    },
    [path, dispatch],
  );

  return (
    <SelectStyleInput
      name={`${FONT_FAMILY_FIELD}-select-${path}`}
      editable={editable}
      defaultValue={defaultValue}
      label='Font family'
      placeholder='Select a font'
      field={FONT_FAMILY_FIELD}
      options={fontOptions}
      onChange={handleChange}
    />
  );
};

export default FontFamilySelect;
